import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { CarFront, CheckCircle2 } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { API } from '@/utils/api';
import { fmtRange } from '../agendaUtils';
import { CheckInDialog } from './CheckInDialog';
import { CheckOutDialog } from './CheckOutDialog';

export const ArrivalsTodayWidget = () => {
  const [list, setList] = useState([]);
  const [current, setCurrent] = useState(null);
  const [out, setOut] = useState(null);
  const navigate = useNavigate();
  const load = useCallback(() => axios.get(`${API}/agenda/arrivals`).then(r => setList(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const pending = list.filter(a => !a.checked_in).length;
  return (
    <Card className="p-4 rounded-xl" data-testid="arrivals-today-widget">
      <div className="flex items-center gap-2 mb-3">
        <CarFront className="w-5 h-5" /><h2 className="font-bold">Arrivées du jour</h2>
        <span className="ml-auto text-xs px-2 py-0.5 rounded-full bg-[#FACC15] font-bold" data-testid="arrivals-pending-count">{pending} à réceptionner</span>
      </div>
      {list.length === 0 && <p className="text-sm text-slate-500">Aucun rendez-vous aujourd'hui.</p>}
      <div className="space-y-1.5">
        {list.map(a => (
          <div key={a.id} className="flex items-center gap-3 p-2.5 rounded-lg border hover:bg-slate-50 transition-colors" data-testid={`arrival-${a.id}`}>
            <span className="text-sm font-bold w-28 shrink-0">{fmtRange(a.time, a.end_time)}</span>
            <div className="flex-1 min-w-0 text-sm"><p className="font-semibold truncate">{a.client_name}</p><p className="text-xs text-slate-500 truncate">{a.vehicle_info || 'Véhicule à compléter'} · {a.intervention_type}</p></div>
            {a.checked_out
              ? <span className="text-xs text-emerald-700 font-semibold flex items-center gap-1" data-testid={`arrival-returned-${a.id}`}><CheckCircle2 className="w-4 h-4" />Restitué</span>
              : a.checked_in
              ? <div className="flex items-center gap-2">
                  <button type="button" onClick={() => a.work_order_id && navigate(`/admin/work-orders/${a.work_order_id}`)} className="text-xs text-emerald-700 font-semibold flex items-center gap-1" data-testid={`arrival-done-${a.id}`}><CheckCircle2 className="w-4 h-4" />Réceptionné</button>
                  <Button size="sm" variant="outline" onClick={() => setOut(a)} data-testid={`arrival-checkout-btn-${a.id}`}>Restituer</Button>
                </div>
              : <Button size="sm" className="bg-[#0E1116] text-[#FACC15] hover:bg-black" onClick={() => setCurrent(a)} data-testid={`arrival-checkin-btn-${a.id}`}>Réceptionner</Button>}
          </div>
        ))}
      </div>
      {current && <CheckInDialog key={current.id} appt={current} onClose={() => setCurrent(null)} onDone={() => { setCurrent(null); load(); }} />}
      {out && <CheckOutDialog key={out.id} appt={out} onClose={() => setOut(null)} onDone={() => { setOut(null); load(); }} />}
    </Card>
  );
};
